export const actionStarted = type => ({
    type,
});

export const actionSuccessfullyFinished = (type, response = {}) => ({
    type,
    ...response,
});

export const actionFinishedWithError = (type, error) => ({
    type,
    error,
});

/**
 * @param {Object} actionTypes - Object with `START`, `SUCCESS`, `ERROR` actions
 * @param {String} actionTypes.START - Start action type
 * @param {String} actionTypes.SUCCESS - Success action type
 * @param {String} actionTypes.ERROR - Error action type
 * @param {Function} apiCall - call to server with provided params `apiCall(...apiParams)`
 * @param {Object} apiActionConfigObject includes not requiered params:
 * @param {Function} apiActionConfigObject.preApiCallCalback - calls before apiCall()
 * @param {Function} apiActionConfigObject.afterApiCallCalback - calls after `apiCall()`
 * @param {Array} apiActionConfigObject.apiParams - `apiCall(...apiParams)`
 * @param {Object} apiActionConfigObject.additionalResponseParams - additional response included to returning value
 */

export const apiActionCreator = async (
    dispatch,
    actionTypes,
    apiCall,
    apiActionConfigObject = {},
) => {
    const {
        apiParams = [],
        additionalResponseParams = {},
        afterApiCallCalback = () => {},
        preApiCallCalback = () => {},
        isNeededStartAction = true,
    } = apiActionConfigObject;
    const { START, SUCCESS, ERROR } = actionTypes;
    try {
        if (isNeededStartAction) {
            dispatch(actionStarted(START));
        }
        await preApiCallCalback();
        const response = await apiCall(...apiParams);
        dispatch(actionSuccessfullyFinished(SUCCESS, { response, additionalResponseParams }));
        await afterApiCallCalback(response);
    } catch (error) {
        dispatch(actionFinishedWithError(ERROR, { error, ...additionalResponseParams }));
    }
};

/**
 * @param {Object} actionTypes - Object with `START`, `SUCCESS`, `ERROR` actions
 * @param {String} actionTypes.START - Start action type
 * @param {String} actionTypes.SUCCESS - Success action type
 * @param {String} actionTypes.ERROR - Error action type
 * @param {Object} apiCallsConfig - `[ACTION.SUCCESS]`: `apiCall()`
 * @param {Array} apiCalls - call to server with provided params `apiCall(...apiParams)`
 * @param {Object} additionalResponseParams - additional response included to returning value
 *
 */
export const multyApiCallActionCreator = async (
    dispatch,
    apiCallsConfig,
    actionTypes,
    additionalResponseParams = {},
) => {
    const { START, SUCCESS, ERROR } = actionTypes;
    try {
        dispatch(actionStarted(START));
        const apiCalls = Object.values(apiCallsConfig);
        const successfulApiActionTypes = Object.keys(apiCallsConfig);
        const responses = await Promise.all(apiCalls.map(apiCall => apiCall()));
        responses.forEach(
            (response, index) =>
                response &&
                dispatch(
                    actionSuccessfullyFinished(successfulApiActionTypes[index], {
                        response,
                        additionalResponseParams,
                    }),
                ),
        );
        dispatch(actionSuccessfullyFinished(SUCCESS));
    } catch (error) {
        dispatch(actionFinishedWithError(ERROR, { error }));
    }
};
